interface IProps {
  numberOfPages: number;
}

function PagesInDocument({ numberOfPages }: IProps) {
  return (
    <tr>
      <th className="label">
        <label htmlFor="cq-pod-numPages">Number of Pages</label>
        <span
          className="woo-selected-variation-item-name"
          data-default=""
        ></span>
      </th>
      <td className="value">
        <input
          type="number"
          readOnly={true}
          name="cq-pod-numPages"
          value={numberOfPages}
        />
      </td>
    </tr>
  );
}

export default PagesInDocument;
